import httpService from "./httpService";

const PIApi = {
    getPIData: (limit, page, search, phase_id, pm_id) => {
        const params = {
            limit,
            page: page,
            searchData: search,
            phase_id, 
            pm_id,
            role_slug: "investigator"
        };
        
        return httpService.get(`pmListForInvestigator`, { params });
    },
    // updatePhase: (editor_id, phase_ids) => httpService.post(`assignEditorToPhase`, {
    //     editor_id,
    //     phase_ids
    // }),
   
      getSubjectList: (
        phase_id,
        page,
        limit,
        searchData,
        user_id,
        investigator_id,
        status,
        gender,
        orderBy,
        order,
        userDetails_id = "" // Add user_id parameter with default value
      ) => {
    
        return httpService.get(
          `subjectList?phase_id=${
            phase_id || ""
          }&page=${page}&limit=${limit}&searchData=${searchData || ""}&user_id=${
            user_id || ""
          }&investigator_id=${investigator_id || ""}&status=[${
            status || ""
          }]&gender=${gender || ""}&sort_by=${orderBy || ""}&order_by=${
            order || ""
          }${userDetails_id ? `&user_id=${userDetails_id}` : ""}` 
        );
      },
}
export default PIApi;